<template>
  <div class="footer">
    <mq-layout mq="lg+">
      <div class="cite">
        <div class="image">
          <img src="@/assets/images/allgemein/cite_sign.png" alt="" />
        </div>
        <div class="text">
          <BaseCitesFade2 class="" />
        </div>
      </div>
    </mq-layout>
    <BaseFooter />
    <div class="billing" :class="$mq">
      <img src="@/assets/images/footer/billing.png" alt="" />
    </div>
    <BasePress />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.footer {
  padding-bottom: 2em;
  background-color: var(--clr-blau);
  .cite {
    color: white;
    text-align: center;
    padding-block: 2em;
    font-size: 1.6rem;
    .image {
      margin-bottom: 5px;
    }
    .text {
      margin-top: 10px;
    }
  }
  .billing {
    text-align: center;
    &.sm,
    &.md {
      padding-inline: 2em;
      img {
        width: 100%;
      }
    }
  }
}
</style>
